<template>
  <div class="face">
    <NavBar v-if="sourceIsH5" :narBarTitle="$t('人脸采集')" />
    <h3 class="face-title">{{ $t('我的人脸照片') }}</h3>
    <input type="file" name="img" @change="imgChange" ref="fileInput" style="display: none" accept="image/*" />
    <div class="my-face">
      <img :src="photo" />
      <div v-if="ifSending" class="img-loading">
        <van-loading type="spinner" />
      </div>
      <div class="photo-box">
        <van-button color="linear-gradient(to right, #00BDFF, #0068F4)" class="photo-btn" size="large" round type="info"
          @click="triggerFileInput">{{ $t('重新拍') }}</van-button>
        <h5-cropper hide-input ref="cropper" :option="option" @getFile="getFile"
          @getbase64Data="getbase64Data"></h5-cropper>
      </div>
    </div>
    <div class="example-block">
      <div class="example-line"></div>
      <img src="@/assets/images/exampleFaceNew.png" class="example-img" />
    </div>
    <!-- <h3 class="face-title">{{ $t('免冠照片示例图') }}</h3>
    <div class="img-example">
      <img src="@/assets/images/exampleFace.png" />
      <div class="matters-needing-attention">
        <p>{{ $t('注意事项：') }}</p>
        <p>{{ $t('1、请保持人脸在相片中间位置；') }}</p>
        <p>{{ $t('2、请保证拍摄光线正常；') }}</p>
        <p>{{ $t('3、请正对摄像头，不要有其他遮挡物；') }}</p>
        <p>{{ $t('照片仅用于门禁开门，不会泄漏给第三方') }}</p>
      </div>
    </div> -->

    <canvas ref="canvas" style="width: 100%" />
    <canvas ref="canvas2" style="width: 100%" />

    <div class="save-box">
      <van-button color="linear-gradient(to right, #00BDFF, #0068F4)" size="large" round type="info"
        @click="saveFaceUrl">{{ $t('保存人像') }}</van-button>
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import Vue from 'vue'
import { Icon, Button, Toast, Loading } from 'vant'
import { saveStaffFace, queryStaffToekn, uploadFace } from '@/services/api'
import H5Cropper from 'vue-cropper-h5'
import defaultFacePhoto from '@/assets/images/defaultFaceImg.png'

import { faceAlignCrop, faceRotation } from '@/utils/img/faceAlignCrop'

Vue.use(H5Cropper)
Vue.use(Icon)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Loading)

export default {
  name: 'faceCollection',
  components: {
    NavBar,
  },
  data() {
    return {
      option: {
        fixedNumber: [1, 1],
        confirmButtonBackgroundColor: '#009BFF',
        cancelButtonText: this.$t('取消'),
        confirmButtonText: this.$t('确认'),
      },
      ifSending: false,
      facePhotoUrl: '',
      photo: defaultFacePhoto,
      sourceIsH5: true,
    }
  },
  methods: {
    async imgChange({ target }) {
      this.$refs.cropper.loadFile(await faceRotation(target.files[0], 0))
      target.value = ''
    },
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    async fetchUserData() {
      let user = JSON.parse(localStorage.getItem('user'))
      const newUser = await queryStaffToekn({ token: user.token })
      if (newUser.facePhoto) {
        this.photo = newUser.facePhoto
        this.facePhotoUrl = newUser.facePhoto
      }
      localStorage.setItem('user', JSON.stringify(newUser))
    },

    async getFile(data) {
      try {
        console.log(data, 'data')
        this.ifSending = true
        const file = await faceAlignCrop(data)
        const formData = new FormData()
        formData.append('file', file)

        const res = await uploadFace(formData)
        console.log(res, 'res')
        this.facePhotoUrl = res
        this.photo = res
        this.ifSending = false
        Toast.success(this.$t('图片上传成功'))
      } catch (error) {
        this.ifSending = false
        Toast.fail(error?.message ?? this.$t('图片上传失败'))
        this.photo = this.facePhotoUrl
      }
    },
    getbase64Data(data) {
      this.photo = data
    },
    async saveFaceUrl() {
      if (this.ifSending) {
        Toast.fail(this.$t('人脸识别照片上传中,请稍等'))
        return
      }
      if (!this.facePhotoUrl) {
        Toast.fail(this.$t('请上传照片'))
        return
      }
      let user = JSON.parse(localStorage.getItem('user'))
      try {
        await saveStaffFace(user.id, { faceUrl: this.facePhotoUrl })
        Toast.success(this.$t('保存成功！'))
        this.$router.back()
      } catch (error) {
        Toast.fail(this.$t('保存失败，请重试！'))
      }

      const newUser = await queryStaffToekn({ token: user.token })
      if (newUser.facePhoto) {
        this.facePhotoUrl = newUser.facePhoto
      }
      localStorage.setItem('user', JSON.stringify(newUser))
    },
  },

  mounted() {
    this.fetchUserData()
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
}
</script>
<style lang="less" scoped>
.face {
  height: 100%;
  background: #f9f9f9;
  padding-top: 1px;

  .face-title {
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    color: #1E2329;
    text-align: center;
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .my-face {
    width: 100%;
    height: 126px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
    padding-right: 18px;
    position: relative;

    img {
      width: 126px;
      height: 126px;
      margin-left: 16px;
      margin-right: 60px;
      object-fit: cover;
    }

    .img-loading {
      width: 126px;
      height: 126px;
      z-index: 999;
      position: absolute;
      left: 16px;
      right: 60px;
      background: rgba(0, 0, 0, 0.3);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .photo-box {
      height: 50px;
      width: 156px;
      position: relative;

      .photo-btn {
        position: absolute;
      }
    }
  }

  .img-example {
    width: 100%;
    height: 196px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 3px;

    img {
      width: 146px;
      height: 196px;
      margin-left: 6px;
    }

    .matters-needing-attention {
      width: 186px;
      border: 1px solid #d9d9d9;
      margin-right: 23px;
      padding: 0 8px;

      p {
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 22px;
      }
    }
  }

  .save-box {
    width: 100%;
    padding: 0 24px;
    position: absolute;
    bottom: 50px;
  }

  .example-line {
    margin-bottom: 24px;
    border-bottom: 1px dashed #B7BDC6;
    width: 335px;
  }

  .example-block {
    width: 100%;
    // height: 196px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
  }

  .example-img {
    width: 335px;
    height: 298px;
  }
}
</style>
